export enum AuthParams {
  INVITE_ID = 'invite-id',
  ENABLED_PASSWORD = 'pass',
}
